/* tslint:disable */
/* eslint-disable */
import {
    FileTextLineschema,
    FileTextLineschemaFromJSON,
    FileTextLineschemaToJSON,
} from './FileTextLineschema';

export interface FileTextSlice {
    fileId: string;
    mimeType: string;
    startLine: number;
    endLine: number;
    totalLines: number;
    lines: Array<FileTextLineschema>;
}

export function instanceOfFileTextSlice(value: object): boolean {
    return typeof value === 'object' && value != null && 'fileId' in value && 'lines' in value;
}

export function FileTextSliceFromJSON(json: any): FileTextSlice {
    return FileTextSliceFromJSONTyped(json, false);
}

export function FileTextSliceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileTextSlice {
    if (json == null) {
        return json;
    }
    return {
        'fileId': json['fileId'],
        'mimeType': json['mimeType'],
        'startLine': json['startLine'],
        'endLine': json['endLine'],
        'totalLines': json['totalLines'],
        'lines': (json['lines'] as Array<any>).map(FileTextLineschemaFromJSON),
    };
}

export function FileTextSliceToJSON(value?: FileTextSlice | null): any {
    if (value == null) {
        return value;
    }
    return {
        'fileId': value.fileId,
        'mimeType': value.mimeType,
        'startLine': value.startLine,
        'endLine': value.endLine,
        'totalLines': value.totalLines,
        'lines': (value.lines as Array<any>).map(FileTextLineschemaToJSON),
    };
}
